import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {TaskModel} from "../../../../tasks/models/task.model";
import {TaskPurposeType} from "../../../../commons/types/task-purpose.type";

require('./agent-itinerary-edit-list-item.scss');
@Component({
  standalone: false,
  selector: 'app-agent-itinerary-edit-list-item',
  templateUrl: './agent-itinerary-edit-list-item.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentItineraryEditListItemComponent implements OnInit, OnChanges {

  @Input() task: TaskModel;
  @Input() isHighlighted: boolean;
  @Output() onTasksChange = new EventEmitter<any>();

  public internalTaskPurposeTypes = [TaskPurposeType.StartDay, TaskPurposeType.EndDay, TaskPurposeType.StartRoute, TaskPurposeType.EndRoute];

  constructor() {
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.tasks && !changes.tasks.isFirstChange()) {

    }
  }



}
